import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { UPLOADS_QUERY_KEY } from '@/api/queries/upload/key';
import { deleteUpload, uploadFile } from './request';

export const useUploadImages = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      files,
      onUploadProgress,
      destination,
    }: {
      files: File[];
      onUploadProgress?: (percent: number) => void;
      destination?: string;
    }) => {
      const formData = new FormData();
      files.forEach((file) => formData.append('file', file));
      return uploadFile(formData, onUploadProgress, destination);
    },
    onSuccess: ({ response, data }) => {
      toast.success(response || 'Images uploaded successfully');
      queryClient.invalidateQueries({ queryKey: [UPLOADS_QUERY_KEY] });
      return data;
    },
  });
};

export const useDeleteUpload = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUpload,
    onSuccess: ({ response }) => {
      toast.success(response || 'Upload deleted successfully');
      queryClient.invalidateQueries({ queryKey: [UPLOADS_QUERY_KEY] });
    },
  });
};
